<template>
<div>
  <template v-if="$route.name === 'EXSBMessagesPeriodicCreate'">
    <b-row>
      <b-col>
        <router-link :to="{ name: 'EXSBMessagesPeriodicList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col>
                <Form
                  :handle-submit="onSendForm"
                  :values="item"
                  :violations="violations"/>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </template>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Create',
  components: {
    Form
  },
  data () {
    return {
      item: {
        title: '',
        messageType: [],
        recipientType: [],
        private: 0,
        subject: '',
        contentSms: '',
        contentEmail: '',
        sendingDays: '',
        fromValue: '',
        toValue: '',
        vindication: 0,
        sendByDate: 1,
        autoAccept: 0,
        sendingDaysOption: 1,
        state: 1,
        shiftDateFromNow: 0,
        forwardDateFromNow: 0,
        agreementArrearsDays: 0,
        idSenderTypeMail: null,
        idSenderTypeSms: null,
        invoiceStatusTypes: [],
        blockApplication: 0
      }
    }
  },
  watch: {
    created (val) {
      if (val) this.$router.push({ name: 'EXSBMessagesPeriodicList' })
    }
  },
  beforeCreate () {
    checkPagePermission('configuration', 'EXCMNotificationMessageList')
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapGetters({
      created: 'exsbmessagesperiodic/create/created',
      violations: 'exsbmessagesperiodic/create/violations',
      isLoading: 'exsbmessagesperiodic/create/isLoading'
    })
  },
  methods: {
    onSendForm () {
      this.create(this.item)
    },
    ...mapActions({
      create: 'exsbmessagesperiodic/create/create',
      reset: 'exsbmessagesperiodic/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
